import { app } from '../../app.module'
interface AccountInfo {
  accountId: string
  screenName: string
  username: string
  pictureUrl: string
  // グローバルアカウントフラグ(Facebook)
  internationalFlg?: number
  followers: number
  categoryName: string
  subCategoryName: string
  accountUrl: string
  dataFlg: number
  // フォロワー非公開フラグ(Youtube)
  hiddenSubscribersFlg?: number
  memoCount: number
  // アカウント作成日(Twitter)
  createdAt?: string
}

/**
 * アカウント詳細の取得のサービス
 * @param  {Function} Restangular Restangular
 * @param  {Function} $q Promise用
 * @param  {Function} $rootScope rootScope
 * @return {Object} オブジェクト
 */
function AccountDetailData(Restangular, $q, CommonService) {
  /**
   * setAccountBasicData アカウント基本データをセット
   * @param {string} snsType SNSタイプ
   * @param {Object} accountInfo アカウント情報
   * @return {Object} アカウント情報
   */
  function setAccountBasicData(
    snsType: string,
    accountInfo: {
      accountId: string
      screenName: string
      accountScreenName: string
      username: string
      internationalFlg?: number
      accountUsername: string
      pictureUrl: string
      accountPictureUrl: string
      accountFollowers: number
      accountCategoryName: string
      accountSubCategoryName: string
      dataFlg: number
      hiddenSubscribersFlg?: number
      memoCount: number
      createdAt?: string
    }
  ) {
    const account: AccountInfo = {
      accountId: accountInfo.accountId,
      screenName: accountInfo.accountScreenName,
      username: accountInfo.accountUsername,
      pictureUrl: accountInfo.accountPictureUrl,
      followers: accountInfo.accountFollowers,
      categoryName: accountInfo.accountCategoryName,
      subCategoryName: accountInfo.accountSubCategoryName,
      accountUrl: CommonService.setAccountUrl(
        snsType,
        accountInfo.accountId,
        accountInfo.accountUsername
      ),
      dataFlg: accountInfo.dataFlg,
      memoCount: accountInfo.memoCount,
    }
    if (snsType === 'facebook') {
      account.internationalFlg = accountInfo.internationalFlg
    }
    if (snsType === 'twitter') {
      const createdAt = moment(accountInfo.createdAt)
      if (createdAt.isValid()) {
        account.createdAt = moment(accountInfo.createdAt).format('YYYY年MM月DD日')
      }
    }
    if (snsType === 'youtube') {
      account.hiddenSubscribersFlg = accountInfo.hiddenSubscribersFlg
    }

    return account
  }

  function selectFollowers(
    startEndDate: {
      startDate: string
      endDate: string
    },
    accountId: number,
    snsType: string,
    targetType: string,
    dailyFlg: boolean
  ) {
    const deferred = $q.defer()
    const getUrl = `/account/selectFollowers?sns_type=${snsType}&target_type=${targetType}&daily_flg=${dailyFlg}&account_id=${accountId}&start_date=${startEndDate.startDate}&end_date=${startEndDate.endDate}`

    Restangular.all(getUrl)
      .getList()
      .then((result) => {
        deferred.resolve(result[0].data)
      })

    return deferred.promise
  }

  return {
    setAccountBasicData: setAccountBasicData,
    selectFollowers: selectFollowers,
  }
}

/**
 * AccountDetailModalService アカウント詳細表示機能関連のサービスを1つのサービスにオブジェクトとして格納
 * @param {Function} AccountDetailData アカウント詳細の取得に関するService
 * @return {Object} サービスのオブジェクト
 */
function AccountDetailModalService(AccountDetailData) {
  return {
    Data: AccountDetailData,
  }
}

// アカウント詳細モーダル用のサービスを定義
app
  .factory('AccountDetailModalService', AccountDetailModalService)
  .factory('AccountDetailData', AccountDetailData)
